import React from 'react';
import {
    PAGE_SIZE_OPTIONS,
    PATIENT_SEARCH_COLUMNS,
    PATIENT_SORT_FIELDS,
    formatPatientCount,
} from './subparts/patientFilesQuery';

function PatientFilesToolbar({
    isLoading,
    searchTerm,
    searchColumn,
    sortBy,
    sortOrder,
    pageSize,
    pagination,
    showAll,
    onSortByChange,
    onSortOrderChange,
    onPageSizeChange,
    onClearSearch,
}) {
    const searchColumnLabel = PATIENT_SEARCH_COLUMNS.find((item) => item.value === searchColumn)?.label;
    const totalElements = pagination?.totalElements ?? 0;
    const currentPage = (pagination?.number ?? 0) + 1;
    const totalPages = pagination?.totalPages ?? 0;

    return (
        <div className="patient-files-toolbar">
            <div className="patient-files-toolbar__meta">
                <h5 className="patient-files-toolbar__title mb-0">Patient Directory</h5>
                <span className="ecx-page-chip">
                    <i className="bi bi-people" />
                    {formatPatientCount(totalElements)} patient{totalElements === 1 ? '' : 's'}
                </span>
                {totalPages > 0 && (
                    <span className="ecx-page-chip">
                        <i className="bi bi-layers" />
                        Page {currentPage} of {totalPages}
                    </span>
                )}
                {searchTerm?.trim() && !showAll && (
                    <span className="ecx-page-chip">
                        <i className="bi bi-funnel" />
                        {searchColumnLabel}: &quot;{searchTerm.trim()}&quot;
                    </span>
                )}
                {showAll && (
                    <span className="ecx-page-chip">
                        <i className="bi bi-collection" />
                        All active patients
                    </span>
                )}
            </div>

            <div className="patient-files-toolbar__controls">
                {(searchTerm?.trim() || showAll) && (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary ecx-modal__close-btn"
                        onClick={onClearSearch}
                        disabled={isLoading}
                    >
                        <i className="bi bi-x-lg me-1" />
                        Reset
                    </button>
                )}

                <label className="d-flex align-items-center gap-2 mb-0 small text-muted">
                    Sort
                    <select
                        className="form-select form-select-sm"
                        style={{ width: '9.5rem' }}
                        value={sortBy}
                        onChange={(e) => onSortByChange(e.target.value)}
                        disabled={isLoading}
                    >
                        {PATIENT_SORT_FIELDS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                    <select
                        className="form-select form-select-sm"
                        style={{ width: '6.5rem' }}
                        value={sortOrder}
                        onChange={(e) => onSortOrderChange(e.target.value)}
                        disabled={isLoading}
                    >
                        <option value="ASC">Asc</option>
                        <option value="DESC">Desc</option>
                    </select>
                </label>

                <label className="d-flex align-items-center gap-2 mb-0 small text-muted">
                    Show
                    <select
                        className="form-select form-select-sm"
                        style={{ width: '5rem' }}
                        value={pageSize}
                        onChange={(e) => onPageSizeChange(Number(e.target.value))}
                        disabled={isLoading}
                    >
                        {PAGE_SIZE_OPTIONS.map((size) => (
                            <option key={size} value={size}>
                                {size}
                            </option>
                        ))}
                    </select>
                    entries
                </label>
            </div>
        </div>
    );
}

export default PatientFilesToolbar;
